(function($){
	$('.chapter h3').click(function(){
		$(this).parent().toggleClass('plegat');
	});
})(jQuery);